import { ResponsiveBar } from '@nivo/bar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatInteger } from '../../../common/formatHelper';
import { TaskSummary } from '../../types/metrics';

interface TaskThroughputChartProps {
  data: TaskSummary[];
}

const TaskThroughputChart: React.FC<TaskThroughputChartProps> = ({ data }) => {
  const { t } = useTranslation('app');

  // Transform data for bar chart
  const barData = data.reduce((acc, curr) => {
    const existingGroup = acc.find(item => item.groupKey === curr.groupKey);
    if (existingGroup) {
      existingGroup[curr.state.toLowerCase()] = curr.volume;
    } else {
      acc.push({
        groupKey: curr.groupKey,
        [curr.state.toLowerCase()]: curr.volume,
      });
    }
    return acc;
  }, [] as any[]);

  return (
    <div className="bg-app-panel-dark h-[400px] rounded-lg p-4">
      <h3 className="mb-4 text-lg font-semibold text-white">
        {t('Task Throughput')}
      </h3>
      <ResponsiveBar
        data={barData}
        keys={['open', 'in_progress', 'done']}
        indexBy="groupKey"
        margin={{ top: 20, right: 130, bottom: 50, left: 60 }}
        padding={0.3}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={{ scheme: 'category10' }}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: t('Task Type'),
          legendPosition: 'middle',
          legendOffset: 40,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: t('Volume'),
          legendPosition: 'middle',
          legendOffset: -40,
          format: value => formatInteger(value),
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor="rgba(255, 255, 255, 0.9)"
        legends={[
          {
            dataFrom: 'keys',
            anchor: 'bottom-right',
            direction: 'column',
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: 'left-to-right',
            itemOpacity: 0.85,
            symbolSize: 20,
            itemTextColor: 'rgba(255, 255, 255, 0.9)',
            effects: [
              {
                on: 'hover',
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        theme={{
          axis: {
            ticks: {
              text: {
                fill: 'rgba(255, 255, 255, 0.5)',
              },
            },
            legend: {
              text: {
                fill: 'rgba(255, 255, 255, 0.9)',
              },
            },
          },
          grid: {
            line: {
              stroke: 'rgba(162, 188, 204, 0.15)',
            },
          },
          legends: {
            text: {
              fill: 'rgba(255, 255, 255, 0.9)',
            },
          },
        }}
        animate={true}
      />
    </div>
  );
};

export default TaskThroughputChart;
